import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitleMerges } from "../api/titleMergeService";
export var useTitleMerges = function (titleId) {
    var kyInstance = useOkapiKy();
    var _a = useQuery(["title-merges", titleId], function () { return fetchTitleMerges(kyInstance, titleId); }, { enabled: !!titleId }), _b = _a.data, merges = _b === void 0 ? [] : _b, isLoading = _a.isLoading, isError = _a.isError;
    return { merges: merges, isMergesLoading: isLoading, isMergesError: isError };
};
